import * as React from "react"

const MOBILE_BREAKPOINT = 768

const subscribe = (onStoreChange: () => void) => {
  const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
  mql.addEventListener("change", onStoreChange)
  return () => mql.removeEventListener("change", onStoreChange)
}

const getSnapshot = () => window.innerWidth < MOBILE_BREAKPOINT

export function useIsMobile() {
  return React.useSyncExternalStore(subscribe, getSnapshot, () => false)
}

export const LG_BREAKPOINT = 1024

const subscribeBelowLg = (onStoreChange: () => void) => {
  const mql = window.matchMedia(`(max-width: ${LG_BREAKPOINT - 1}px)`)
  mql.addEventListener("change", onStoreChange)
  return () => mql.removeEventListener("change", onStoreChange)
}

const getBelowLgSnapshot = () => window.innerWidth < LG_BREAKPOINT

export function useIsBelowLg() {
  return React.useSyncExternalStore(subscribeBelowLg, getBelowLgSnapshot, () => false)
}
